import { AppModal, AppModalContent, AppModalFooter } from 'shared/UI/UIKit/Modal';
import { AppForm, AppFormItem } from 'shared/UI/UIKit/Form';
import { AppSelect } from 'shared/UI/UIKit/Select';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppPlusIcon } from 'shared/UI/UIKit/icons/Plus';
import { CreateTeacherWorkloadModal } from 'entities/teacher-workload';
import type { ScheduleLesson } from 'services/api';
import { useLessonModal } from '../model/use-lesson-modal';
import { AddRoomLessonModal } from '../../AddRoomLessonModal';
import styles from './styles.module.scss';

export type LessonModalProps = {
  open: boolean;
  onClose: () => void;
  lesson: ScheduleLesson;
};

export const LessonModal = ({ open, onClose, lesson }: LessonModalProps) => {
  const {
    state: {
      form,
      teacherOptions,
      roomOptions,
      loading,
      addTeacherWorkloadLessonModalVisible,
      addRoomLessonModalVisible,
      isEditScheduleLoading,
    },
    methods: {
      handleSave,
      refreshTeachers,
      refreshRooms,
      setAddTeacherWorkloadLessonModalVisible,
      setAddRoomLessonModalVisible,
    },
  } = useLessonModal(lesson, open, onClose);

  return (
    <>
      <AppModal
        visible={open}
        onCancel={onClose}
        loading={loading}
        title="Редактировать урок"
        content={
          <AppModalContent>
            <AppForm form={form}>
              <AppFormItem label="Предмет" labelColor="gray" size="max">
                {lesson.subject.name}
              </AppFormItem>
              <AppFlex
                direction="row"
                unit="12"
                alignItems="center"
                className={styles.addContainer}
              >
                <AppFormItem
                  label="Преподаватель"
                  labelColor="gray"
                  size="max"
                  name="teacherId"
                  rules={[{ required: true, message: 'Выберите преподавателя' }]}
                  className={styles.addSelect}
                >
                  <AppSelect options={teacherOptions} placeholder="Выберите преподавателя" />
                </AppFormItem>
                <AppButton
                  type="text"
                  onClick={() => setAddTeacherWorkloadLessonModalVisible(true)}
                  icon={<AppPlusIcon className={styles.addIcon} />}
                  className={styles.addButton}
                />
              </AppFlex>
              <AppFlex
                direction="row"
                unit="12"
                alignItems="center"
                className={styles.addContainer}
              >
                <AppFormItem
                  label="Кабинет"
                  labelColor="gray"
                  size="max"
                  name="roomId"
                  rules={[{ required: true, message: 'Выберите кабинет' }]}
                  className={styles.addSelect}
                >
                  <AppSelect options={roomOptions} placeholder="Выберите кабинет" />
                </AppFormItem>
                <AppButton
                  type="text"
                  onClick={() => setAddRoomLessonModalVisible(true)}
                  icon={<AppPlusIcon className={styles.addIcon} />}
                  className={styles.addButton}
                />
              </AppFlex>
            </AppForm>
          </AppModalContent>
        }
        customFooter={
          <AppModalFooter direction="row" unit="8" justifyContent="flex-end">
            <AppFlex direction="row" unit="8" justifyContent="flex-end">
              <AppButton type="outline" onClick={onClose}>
                Отмена
              </AppButton>
              <AppButton type="primary" onClick={handleSave} disabled={isEditScheduleLoading}>
                Сохранить
              </AppButton>
            </AppFlex>
          </AppModalFooter>
        }
      />
      <CreateTeacherWorkloadModal
        visible={addTeacherWorkloadLessonModalVisible}
        hide={() => setAddTeacherWorkloadLessonModalVisible(false)}
        onSuccess={refreshTeachers}
      />
      <AddRoomLessonModal
        visible={addRoomLessonModalVisible}
        hide={() => setAddRoomLessonModalVisible(false)}
        onSuccess={refreshRooms}
      />
    </>
  );
};
